import { hashHistory } from 'react-router';

// Get 'app' path
import { path as APP_PATH } from '../..';

// All paths
const PATHS = {
  SIMCARDS: 'simcards',
  INFORMATION: 'information',
  DEVICE: 'device',
};

// Exported paths
export const MAIN_PATH = PATHS.SIMCARDS;
export const INFORMATION_PATH = PATHS.INFORMATION;
export const DEVICE_PATH = PATHS.DEVICE;

// Root
const APP_SIMCARDS_PATH = `${APP_PATH}/${MAIN_PATH}`;

export const listPath = () => APP_SIMCARDS_PATH;
export const navigateToList = () => {
  hashHistory.push(listPath());
};

export const addPath = () => `${APP_SIMCARDS_PATH}/add`;
export const navigateToAdd = () => {
  hashHistory.push(addPath());
};

export const importPath = () => `${APP_SIMCARDS_PATH}/import`;
export const navigateToImport = () => {
  hashHistory.push(importPath());
};

export const showPath = (id) => `${APP_SIMCARDS_PATH}/${id}`;
export const navigateToShow = (id) => {
  hashHistory.push(showPath(id));
};



// WEBPACK FOOTER //
// ./routes/app/routes/simcards/navigation.js